import { render } from "./DemoAccessPanel.vue?vue&type=template&id=4c09647c&scoped=true"
import script from "./DemoAccessPanel.vue?vue&type=script&lang=js"
export * from "./DemoAccessPanel.vue?vue&type=script&lang=js"

import "./DemoAccessPanel.vue?vue&type=style&index=0&id=4c09647c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c09647c"]])

export default __exports__